module.exports = __webpack_public_path__ + "img/displayscombined.38742444.jpg";